import { useEffect, useState } from "react"
import { default as routes} from "api/routes"
import axios from "axios"
import {Message} from "api/wshub/wshub.pb"
import * as tokens from "api/auth/tokens"

interface props {
    callback(m: Message, ws:WebSocket): void
}

export function WshubComponent(props: React.PropsWithChildren<props>) : JSX.Element {
    const { callback } = props
    const [socket, setSocket] = useState<WebSocket | null>(null)
    
    useEffect(() => {
        setSocket(openWs())
    }, [ ])

    useEffect(() => {
        if(!socket){
            const tWs = setTimeout(function(){
                setSocket(openWs())
            }, 5000)
            return () => clearTimeout(tWs)
        }

        return () => {
            socket.close(1000)
        }
    }, [ socket ])

    function openWs(): WebSocket {
        const ws = new WebSocket(routes.wspoll())
        ws.onopen = () => {
            console.debug("wss: connection open", ws)
            axios
                .get(routes.checkAuth(), {
                    headers: tokens.headerToken(tokens.lastAccessToken())
                })
                .then(() => {
                    ws.send(tokens.lastAccessToken());
                })
                .catch((e) => {
                    console.debug("wss: error on check auth", e)
                    if (e.response.status === 401) {
                        tokens.tokenRefresher.refreshToken()
                        .then(() => {
                            ws.close()
                        })
                        .catch((e) => {
                            console.debug("wss: error on refresh auth", e)
                            tokens.deleteAccessToken()
                            ws.close(1000)
                        })
                    } else {
                        ws.close(1000)
                    }
                })
        }

        ws.onclose = (c) => {
            console.debug("wss: connection close", ws, c)
            if (c.code !== 1000 && c.code !== 1006) {
                setSocket(openWs())
            } else {
                setSocket(null)
            }
        }

        ws.onmessage = (e) => {
            const message = JSON.parse(e.data) as Message
            callback(message, ws)
        }
        return ws
    }

    return <>{props.children}</>
}
